module.exports = __webpack_public_path__ + "img/addIcon.3d66d7d1.svg";